import { translations } from './translations.js';

class I18n {
    constructor() {
        const savedLang = localStorage.getItem('ily-language');
        const langCode = savedLang || 'es';
        
        this.currentLang = langCode;
        this.translations = translations[this.currentLang] || translations.es;
    }

    /**
     * Sets current language and updates page
     * @param {string} lang - Language code ('es' or 'en')
     */
    setLanguage(lang) {
        if (translations[lang]) {
            this.currentLang = lang;
            this.translations = translations[lang];
            localStorage.setItem('ily-language', lang);
            this.updatePage();
        }
    }

    /**
     * @returns {string} Current language code
     */
    getLanguage() {
        return this.currentLang;
    }

    /**
     * Gets translated text for key with optional parameter replacement
     * @param {string} key - Translation key
     * @param {Object} params - Parameters to replace in format {name: value}
     * @returns {string} Translated text
     */
    t(key, params = {}) {
        let text = this.translations[key] || key;
        
        if (params && typeof text === 'string') {
            Object.keys(params).forEach(param => {
                text = text.replace(new RegExp(`\\{${param}\\}`, 'g'), params[param]);
            });
        }
        
        return text;
    }

    /**
     * Updates all elements with data-i18n attribute with current language translations
     */
    updatePage() {
        document.querySelectorAll('[data-i18n]').forEach(element => {
            const key = element.getAttribute('data-i18n');
            const text = this.t(key);
            
            if (element.tagName === 'INPUT' && element.type !== 'submit' && element.type !== 'button') {
                if (element.hasAttribute('placeholder')) {
                    element.placeholder = text;
                } else {
                    element.value = text;
                }
            } else if (element.tagName === 'SELECT') {
                // For select elements, update the label if it exists, not the select itself
                const label = element.closest('.form-group')?.querySelector('label');
                if (label && label.getAttribute('for') === element.id) {
                    // Label will be updated by its own data-i18n attribute
                }
            } else if (element.tagName === 'OPTION') {
                element.textContent = text;
            } else if (element.tagName === 'IMG' && element.hasAttribute('alt')) {
                element.alt = text;
            } else {
                element.innerHTML = text;
            }
        });

        const titleKey = document.querySelector('title')?.getAttribute('data-i18n');
        if (titleKey) {
            document.title = this.t(titleKey);
        }
    }
}

export default new I18n();

